// Kombinierter Referenzen-Filter: Dual-Range „Planungs- und Bauzeit" (Jahre)
// + Mehrfach-Auswahl „Baukosten"-Pills. Ein Eintrag ist sichtbar, wenn er beide
// Bedingungen erfüllt. Trifft die Auswahl keinen Eintrag, erscheint der
// Leerzustand ([data-reffilter-empty]) mit Hinweis + „Filter zurücksetzen"
// ([data-reffilter-reset], stellt Range und Pills zurück) — NUR dort, sonst kein
// Reset-Button. Kein Inline-JS (§8).
//   <div data-reffilter>
//     <div data-range> <input data-range-lower> <input data-range-upper> … </div>
//     <button data-reffilter-pill="2">…</button>
//     <a data-filter-item data-filter-tags="2" data-year-min="2017" data-year-max="2020">
//     <p data-reffilter-empty hidden>… <button data-reffilter-reset>…</button></p>
//   </div>
import { animateFilter } from "./filteranim.js";

export function initRefFilter() {
  document.querySelectorAll("[data-reffilter]").forEach((root) => {
    const items = [...root.querySelectorAll("[data-filter-item]")];

    // --- Dual-Range (Jahre) ---
    const range = root.querySelector("[data-range]");
    let lower = null;
    let upper = null;
    let rangeMin = -Infinity;
    let rangeMax = Infinity;
    let lowerV = -Infinity;
    let upperV = Infinity;
    let syncRange = () => {};

    if (range) {
      lower = range.querySelector("[data-range-lower]");
      upper = range.querySelector("[data-range-upper]");
      const fill = range.querySelector("[data-range-fill]");
      const outMin = range.querySelector("[data-range-out-min]");
      const outMax = range.querySelector("[data-range-out-max]");
      rangeMin = Number(lower.min);
      rangeMax = Number(lower.max);
      const span = rangeMax - rangeMin || 1;

      syncRange = () => {
        let lo = Number(lower.value);
        let up = Number(upper.value);
        if (lo > up) {
          [lo, up] = [up, lo];
        }
        lowerV = lo;
        upperV = up;
        if (outMin) outMin.textContent = lo;
        if (outMax) outMax.textContent = up;
        if (fill) {
          fill.style.insetInlineStart = `${((lo - rangeMin) / span) * 100}%`;
          fill.style.insetInlineEnd = `${((rangeMax - up) / span) * 100}%`;
        }
      };

      lower.addEventListener("input", () => {
        if (Number(lower.value) > Number(upper.value)) lower.value = upper.value;
        syncRange();
        apply();
      });
      upper.addEventListener("input", () => {
        if (Number(upper.value) < Number(lower.value)) upper.value = lower.value;
        syncRange();
        apply();
      });
      syncRange();
    }

    // --- Baukosten-Pills (Mehrfachauswahl, standardmäßig alle aktiv) ---
    const pills = [...root.querySelectorAll("[data-reffilter-pill]")];
    const active = new Set(pills.map((p) => p.dataset.reffilterPill));
    pills.forEach((p) => {
      p.classList.add("is-active");
      p.setAttribute("aria-pressed", "true");
      p.addEventListener("click", () => {
        const v = p.dataset.reffilterPill;
        if (active.has(v)) active.delete(v);
        else active.add(v);
        const on = active.has(v);
        p.classList.toggle("is-active", on);
        p.setAttribute("aria-pressed", on ? "true" : "false");
        apply();
      });
    });

    // --- Leerzustand + Reset (Reset erscheint nur im Leerzustand) ---
    const empty = root.querySelector("[data-reffilter-empty]");
    const resets = [...root.querySelectorAll("[data-reffilter-reset]")];

    const matches = (it) => {
      const yMin = Number(it.dataset.yearMin);
      const yMax = Number(it.dataset.yearMax);
      const yearOk =
        !range || Number.isNaN(yMin) || (yMax >= lowerV && yMin <= upperV);

      const tags = (it.dataset.filterTags || "").split(",").filter(Boolean);
      const pillOk =
        0 === pills.length || 0 === tags.length || tags.some((t) => active.has(t));

      return yearOk && pillOk;
    };

    const resetAll = () => {
      if (range) {
        lower.value = lower.min;
        upper.value = upper.max;
        syncRange();
      }
      pills.forEach((p) => {
        active.add(p.dataset.reffilterPill);
        p.classList.add("is-active");
        p.setAttribute("aria-pressed", "true");
      });
      apply();
    };

    resets.forEach((r) => r.addEventListener("click", resetAll));

    function apply() {
      animateFilter(items, matches);
      const matchCount = items.filter(matches).length;
      // „Filter zurücksetzen" erscheint ausschließlich im Leerzustand (0 Treffer).
      if (empty) empty.hidden = matchCount > 0;
    }

    apply();
  });
}
